import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from '@/store/auth.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
    isAuthenticated: state => !!state.user
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  }
})
